import { Injectable } from '@angular/core';
import { ContextService } from '../services/context.service';

@Injectable({
  providedIn: 'root',
})
export class MockContextService extends ContextService {
  constructor() {
    super();
    this.instance = {
      accessToken: '',
      customerId: 'xyz',
      customerName: 'test customer',
      ctmsEnabled: true,
      ctmsUrl: '',
      footerText: '',
      footerUrl: '',
      lockTimeout: 0,
      loginUrl: '',
      logoutUrl: '',
      userProfileUrl: 'userProfileUrl',
      changePasswordUrl: 'changePasswordUrl',
      studySelectorUrl: 'studySelectorUrl',
      userLanguage: 'en-US',
      logoutTimeout: 0,
      tokenExpiresAt: (new Date()).toString(),
      totalActiveStudies: 0,
      isSSO: false,
      isApiUser: false,
      username: 'testuser',
      warningTimeout: 0,
      helpMenuUrls: [],
      permissions: [],
      isProduction: false,
      customerApiAccessEnabled: false,
      domains: [],
      userDomain: '',
      googleTagManagerId: 'G-XXXXXXXXXX',
    };
  }
}
